import { render } from "./fichaEstatal.vue?vue&type=template&id=05f46a8f&scoped=true"
import script from "./fichaEstatal.vue?vue&type=script&lang=js"
export * from "./fichaEstatal.vue?vue&type=script&lang=js"

import "./fichaEstatal.vue?vue&type=style&index=0&id=05f46a8f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f46a8f"]])

export default __exports__